import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  Icon,
} from "@chakra-ui/react";
import {
  FaClock,
  FaCheckCircle,
  FaCalendarAlt,
  FaFileAlt,
  FaChartLine,
  FaFolderOpen,
  FaGlobe,
  FaEnvelopeOpenText,
  FaFileInvoice,
  FaMoneyBill,
  FaUserCircle,
} from "react-icons/fa";
import SEO from "../SEO";

const features = [
  {
    icon: FaClock,
    title: "Gyors foglalás",
    description:
      " A Wobble időpontfoglaló rendszere segít elkerülni a telefonos és üzenetes foglalásokat és várakozásokat. Kategorizálható egyéni és csoportos szolgáltatások várólistával",
  },
  {
    icon: FaCheckCircle,
    title: "Weboldal",
    description: "Weboldalad megjelenését személyre szabhatod. Szolgáltatások, blog, értékelés, nyitvatartás, lokáció egy helyen",
  },
  {
    icon: FaFolderOpen,
    title: "Admin felület",
    description:
      "A Wobble admin felülete lehetővé teszi, hogy egy helyen kezeld az összes szolgáltatásodat és ügyfeledet, miközben naprakészen tartod az eseményeidet",
  },
  {
    icon: FaFileInvoice,
    title: "Számlázási lehetőség",
    description:
      "Kapcsold össze Számlázz.hu vagy Billingo fiókodat a Wobble fiókoddal, és számlázz gyorsan, egyszerűen a Wobble rendszerén keresztül",
  },
  {
    icon: FaMoneyBill,
    title: "Előlegfizetés",
    description:
      "Kérj előleget ügyfeleidtől. Teljes vagy %-os előlegfizetési lehetőség foglaláskor.",
  },
  {
    icon: FaFileAlt,
    title: "Blog posztok",
    description:
      "Oszd meg mi történik vállalkozásodban. Készíts cikket weboldalaladra egy napodról, új szolgáltatásodról, sikereidről",
  },
  {
    icon: FaGlobe,
    title: "Saját domain",
    description:
      "Használd a saját domain neved, vagy kapsz egy aldomain-t, az ingyenes SSL tanúsítványt mi adjuk",
  },
  {
    icon: FaEnvelopeOpenText,
    title: "Marketing email",
    description:
      "Küldj azonnali, vagy időzített emailt ügyfeleidnek, tájékoztasd klienseidet új szolgáltatáodról vagy kedvezményekről",
  },
  {
    icon: FaChartLine,
    title: "Egyedi kérdőív",
    description:
      "Készíts egyedi kérdőívet a szolgáltatásodhoz, hogy már a foglaláskor minden fontos információt megtudhass az ügyfeledről",
  },
  {
    icon: FaCalendarAlt,
    title: "Google Naptár szinkronizálási lehetőséggel",
    description:
      "Szinkronizáld a Wobble foglalásaidat a Google naptáraddal, hogy könnyedén nyomon követhesd a találkozókat és eseményeket",
  },
  {
    icon: FaUserCircle,
    title: "MyWobble ügyfélfiók",
    description:
      "Ügyfeleid egy helyen kezelhetik foglalásaikat, könnyedén újrafoglalhatnak vagy lemondhatnak időpontokat",
  },
];

const FeatureSection = () => {
  return (
    <>
      <SEO
        title="Funkciók - Wobble időpontfoglaló rendszer"
        description="Ismerd meg a Wobble funkcióit: naptárkezelés, ügyfélkezelés, egyedi kérdőívek, email küldés, számlázás és előlegfizetés egy rendszerben."
        keywords="időpontfoglaló funkciók, naptárkezelés, ügyfélkezelés, CRM, online foglalási rendszer"
        ogTitle="Wobble funkciók - Időpontfoglaló rendszer kisvállalkozásoknak"
        ogDescription="A Wobble időpontfoglaló rendszer teljes funkciólistája kisvállalkozásoknak."
        ogImage="https://wobble.hu/assets/mockup_moov_studio.png"
      />
      <Box
        as="section"
        py={{ base: 10, md: 20 }}
        px={{ base: 4, md: 12 }}
        bg="gray.50"
      >
        <Box maxW="7xl" mx="auto" textAlign="center" mb={12}>
          <Heading
            as="h1"
            mb={8}
            fontSize={{ base: "3xl", md: "5xl" }}
            fontWeight="bold"
            bgGradient="linear(to-r, teal.300, blue.500)"
            bgClip="text"
          >
            Miben segít a rendszer?
          </Heading>
          <Text mt={4} fontSize="lg" color="gray.600">
            Minden funkció egy célt szolgál: hogy neked több időd maradjon a
            valóban fontos dolgokra.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {features.map((feature, index) => (
            <Stack
              key={index}
              spacing={4}
              bg="white"
              p={6}
              borderRadius="2xl"
              shadow="md"
              transition="all 0.2s ease-in-out"
              _hover={{ shadow: "lg", transform: "translateY(-4px)" }}
            >
              <Flex
                align="center"
                justify="center"
                w={12}
                h={12}
                rounded="full"
                bg="blue.100"
                color="blue.600"
                fontSize="xl"
              >
                <Icon as={feature.icon} />
              </Flex>
              <Heading as="h3" size="md" color="gray.800">
                {feature.title}
              </Heading>
              <Text color="gray.600">{feature.description}</Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Box>
    </>
  );
};

export default FeatureSection;
